import { Column, TColumnProps } from '@/components/atoms/Column'

interface IIconContainer extends TColumnProps {
  icon?: React.ReactNode
  onClick?: React.MouseEventHandler<HTMLDivElement>
  children: React.ReactNode
}

export const IconContainer: React.FC<IIconContainer> = ({ icon, onClick, children, ...columnProps }) => (
  <Column onClick={onClick} w="20px" align="center" justify="center" fz="1rem" {...columnProps}>
    {icon ? icon : children}
  </Column>
)
